const style = {
  container: {
    border: `1px solid #ececec`
  },
  inputWrapper: {
    padding: 0
  },
  input: {
    background: `white`,
    border: `none`,
    borderRadius: `3px`,
    borderBottom: `0px`,
    width: `100%`,
    padding: `5px 15px`,
    fontSize: `14px`,
    color: `#666`
  },
  button: {
    width: `100%`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/User/Main/style/search.js